var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "cloud-holder-wrapper"
  }, [_c('client-summary', {
    attrs: {
      "summary-data": _vm.clientData.clientObject,
      "role": _vm.role,
      "opened-default": _vm.opened
    }
  })], 1), _vm._l(_vm.clientData.incomes, function (income, index) {
    return income.is_active && _vm.transformTypeToSummary(income.druh) ? _c('div', {
      key: index + 'income',
      staticClass: "cloud-holder-wrapper"
    }, [_c(_vm.transformTypeToSummary(income.druh), {
      tag: "component",
      attrs: {
        "opened-default": _vm.opened,
        "summary-data": income
      }
    })], 1) : _vm._e();
  }), _vm._l(_vm.clientData.debts, function (debt, index) {
    return _vm.shouldDisplayDebt(debt) ? _c('div', {
      key: index + 'debt',
      staticClass: "cloud-holder-wrapper"
    }, [_c('debt-summary', {
      attrs: {
        "summary-data": debt,
        "opened-default": _vm.opened
      }
    })], 1) : _vm._e();
  })], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }